import { getCookie, setCookie } from '../helpers'

$(() => {
    const cookieAgreement = getCookie('accepted-cookie-agreement')

    if (!cookieAgreement) {
        $('.cookie-banner').fadeIn('slow')
    }
    
    // Dismiss Cookie Banner
    $('.cookie-banner .ok-button').on('click', event => {
        setCookie('accepted-cookie-agreement', 1, 30)

        const parent = $(event.target).closest('.cookie-banner')
        parent.fadeOut()
    })
})